// import sequenceItemModelDefinition from '@/models/sequence/sequenceItem/'
import sequenceActionModelDefinition from '@/models/sequence/sequenceAction/'
import { get_color_rgb } from '@/misc/colors'
// TODO: Move to Realtime DB?

/* --------------------------------- Helper --------------------------------- */

// eslint-disable-next-line
// const make_item = (data) => sequenceItemModelDefinition.schema.create(null, data || {});
const make_action = (type, data) => sequenceActionModelDefinition.schema.create({ itemType: type }, data || {});
// const make_session = (description, sessionLength) => make_action('SESSION', { description, sessionLength });
// const make_pause = (sessionLength) => make_action('PAUSE', { sessionLength });
/*

const make_next_day = (repeat) => make_action('NEXT:DAY', { repeat });
const make_next_week = (repeat) => make_action('NEXT:WEEK', { repeat });
const make_next_weekday = (weekday) => make_action('NEXT:WEEKDAY', { weekday });
const make_next_date = (date) => make_action('NEXT:DATE', { date });

*/

/* ---------------------------------- Icons --------------------------------- */

const hour_glass_icon = { symbol: 'hourglass-start', bgColor: get_color_rgb('blue'), fgColor: get_color_rgb('white') }
const clock_icon = { symbol: 'clock', bgColor: get_color_rgb('green'), fgColor: get_color_rgb('white') }
// const filter_icon = { symbol: 'filter', bgColor: get_color_rgb('blue'), fgColor: get_color_rgb('white') }
// const paper_plane_icon = { symbol: 'paper-plane', bgColor: get_color_rgb('gray'), fgColor: get_color_rgb('black') }
const fast_forward_icon = { symbol: 'fast-forward', bgColor: get_color_rgb('yellow'), fgColor: get_color_rgb('black') }
// const fast_forward_smart_icon = { symbol: 'fast-forward', bgColor: get_color_rgb('indigo'), fgColor: get_color_rgb('white') }
// const toaster_icon = { symbol: 'noun-Toaster-216378', bgColor: get_color_rgb('teal'), fgColor: get_color_rgb('black') }
// const meditation_icon = { symbol: 'noun-meditation-1471256', bgColor: get_color_rgb('red'), fgColor: get_color_rgb('white') }
// const task_icon = { symbol: 'check-circle', bgColor: get_color_rgb('lime'), fgColor: get_color_rgb('white') }

// const task_icon_green = { symbol: 'check-circle', bgColor: '#69b42d', fgColor: get_color_rgb('white') }
// const task_icon_orange = { symbol: 'check-circle', bgColor: '#ed6b06', fgColor: get_color_rgb('white') }
// const task_icon_lightorange = { symbol: 'check-circle', bgColor: '#f9ae00', fgColor: get_color_rgb('white') }
// const task_icon_red = { symbol: 'check-circle', bgColor: '#e30613', fgColor: get_color_rgb('white') }
// const task_icon_blue = { symbol: 'check-circle', bgColor: '#1d3e8a', fgColor: get_color_rgb('white') }
// const task_icon_lightblue = { symbol: 'check-circle', bgColor: '#17abe3', fgColor: get_color_rgb('white') }

/* ------------------------------- Primitives ------------------------------- */

const suggestion_item_list_basic = {
  $id: 1,
  $key: '1',
  title: 'Standard items',
  items: [
    /*make_item(*/{
      $key: 1,
      $id: 1,
      title: 'Session',
      description: 'A basic session.',
      icon: clock_icon,
      actions: [ make_action('SESSION') ]
    },
    {
      $key: 7,
      $id: 7,
      title: 'Task',
      description: 'An existing task, that is used as template for a session.',
      // icon: task_icon,
      actions: [ make_action('SESSION:TASK') ]
    },
    {
      $key: 2,
      $id: 2,
      title: 'Pause',
      description: 'A basic pause between sessions.',
      icon: hour_glass_icon,
      actions: [ make_action('PAUSE') ]
    },
    {
      $key: 3,
      $id: 3,
      title: 'Skip to next day',
      description: 'An instruction to skip to the next (or n-th) day.',
      icon: fast_forward_icon,
      actions: [ make_action('NEXT:DAY') ]
    },
    {
      $key: 4,
      $id: 4,
      title: 'Skip to next week',
      description: 'An instruction to skip to the next (or n-th) week.',
      icon: fast_forward_icon,
      actions: [ make_action('NEXT:WEEK') ]
    },
    {
      $key: 5,
      $id: 5,
      title: 'Skip to weekday',
      description: 'An instruction to wait until a certain weekday before continuing.',
      icon: fast_forward_icon,
      actions: [ make_action('NEXT:WEEKDAY') ]
    },
    {
      $key: 6,
      $id: 6,
      title: 'Skip until date',
      description: 'An instruction to wait until a certain date before continuing.',
      icon: fast_forward_icon,
      actions: [ make_action('NEXT:DATE') ]
    },
    /*
    {
      $key: 8,
      $id: 8,
      title: 'Goalpilot smart break&trade;',
      description: 'An intelligent pause block, that automotically adapt to you.',
      icon: fast_forward_smart_icon,
      actions: [ make_action('NEXT:DATE') ]
      // TODO:
    },
    */
  ]
}

/* ------------------------------- Morning Routine -------------------------- */

/*
const suggestion_item_list_1 = {
  $id: 2,
  $key: '2',
  title: 'Morning routine',
  items: [
    {
      $key: 1,
      $id: 1,
      title: 'Meditate',
      description: 'People also use the practice to develop other beneficial habits and feelings, such as a positive mood and outlook, self-discipline, healthy sleep patterns and even increased pain tolerance.',
      href: "https://www.healthline.com/nutrition/12-benefits-of-meditation",
      icon: meditation_icon,
      actions: [ make_session('Meditate', 30) ]
    },
    {
      $key: 2,
      $id: 2,
      title: 'Simple Workout',
      description: 'A simple workout routine based on a youtube video',
      href: "https://www.youtube.com/watch?v=0r_XSiNwnkY",
      icon: paper_plane_icon,
      actions: [ make_session('Pullups', 5), make_pause(5), make_session('Pushups', 5) ]
    },
    {
      $key: 3,
      $id: 3,
      title: 'Breakfast',
      description: 'This is an example block for a healthy breakfast routine',
      href: "https://www.myrecipes.com/recipe/make-a-week-of-vegan-breakfasts-from-whole-foods-for-less-than-25",
      icon: toaster_icon,
      actions: [ make_session('Make toast', 5), make_session('Drink Coffee', 5), make_session('Be happy', 5) ]
    },
    {
      $key: 4,
      $id: 4,
      title: 'Brush teeth',
      description: 'Studies completed by the Academy of General Dentistry have shown that many of the most damaging of diseases may begin with improper oral care.',
      icon: filter_icon,
      actions: [ make_session('Brush teeth', 10) ]
    },
  ]
}
*/

/* ------------------------------- More .......... -------------------------- */

/*
const suggestion_item_list_2 = {
  $id: 3,
  $key: '3',
  title: 'Categories',
  // icon: filter_icon,
  items: [
    {
      $key: 1,
      $id: 1,
      title: 'Morning Routine',
      description: 'Things you do in the morning to get your day started like taking a shower, eating breakfast, meditation, a quick workout or getting ready for your workday.',
      href: "https://www.moreinfo.com",
      icon: task_icon_green,
      actions: [ make_session('Do stuff', 30) ]
    },
    {
      $key: 2,
      $id: 2,
      title: 'Work & Business',
      description: 'Are you a full-time employee, a half-time employee, a business owner, freelancer or manage a household? Anything that feels like work goes in here.',
      href: "https://www.moreinfo.com",
      icon: task_icon_orange,
      actions: [ make_session('Do stuff', 480) ]
    },
    {
      $key: 3,
      $id: 3,
      title: 'Personal Time',
      description: 'This is time to do things for a perfect personal life. Making sure the household is in great shape, groceries, personal finances, ...',
      href: "https://www.moreinfo.com",
      icon: task_icon_green,
      actions: [ make_session('Do stuff', 60) ]
    },
    {
      $key: 4,
      $id: 4,
      title: 'Family Time',
      description: 'Spending time with your family, partner, kids.',
      href: "https://www.moreinfo.com",
      icon: task_icon_blue,
      actions: [ make_session('Do stuff', 90) ]
    },
    {
      $key: 5,
      $id: 5,
      title: 'Leisure',
      description: 'Things you do to relax, for entertainment, make new experiences, enjoy life.',
      href: "https://www.moreinfo.com",
      icon: task_icon_red,
      actions: [ make_session('Do stuff', 120) ]
    },
    {
      $key: 6,
      $id: 6,
      title: 'Community Time',
      description: 'Everything you do with friends or as a part of a larger community.',
      href: "https://www.moreinfo.com",
      icon: task_icon_lightblue,
      actions: [ make_session('Do stuff', 60) ]
    },
    {
      $key: 7,
      $id: 7,
      title: 'Evening Routine',
      description: 'A routine of things you usually do at night before bed.',
      href: "https://www.moreinfo.com",
      icon: task_icon_green,
      actions: [ make_session('Do stuff', 15) ]
    },
    {
      $key: 8,
      $id: 8,
      title: '5 Potentielle Kunden anrufen',
      description: '0 / 5 Anrufe geplant',
      href: "https://www.moreinfo.com",
      icon: task_icon_green,
      actions: [ make_session('Do stuff', 15) ]
    },
    {
      $key: 9,
      $id: 9,
      title: 'Goalpilot Bugfixing - 3 hours',
      description: '1h / 3h eigneplant',
      href: "https://www.moreinfo.com",
      icon: task_icon_green,
      actions: [ make_session('Do stuff', 15) ]
    },
    {
      $key: 10,
      $id: 10,
      title: 'Goalpilot Development - 5 tasks',
      description: '2 / 5 tasks eigneplant',
      href: "https://www.moreinfo.com",
      icon: task_icon_green,
      actions: [ make_session('Do stuff', 15) ]
    },
  ]
}
*/

export default [
  suggestion_item_list_basic,
  // suggestion_item_list_1,
  // suggestion_item_list_2,
]
